<template>
  <div>
    <Loader v-if="initalLoad" class="loader" />
    <SmFilter
      v-else
      :selectCounter="selectCounter"
      :clearble="!isDefault"
      @clear="resetFilters"
    >
      <div class="appointment-filter">
        <div class="appointment-filter--up">
          <SelectFilter
            v-model="biomaterialSelected"
            title="Вид биоматериала"
            itemTitle="title"
            :items="biomaterialList"
            :clearble="defaultState['biomaterialIds']"
            @submit="() => submitHandler('biomaterialIds', biomaterialSelected)"
            @reset-filter="() => resetFilter('biomaterialIds')"
          />
          <DateFilter
            v-model="dateSelected"
            title="Дата сдачи"
            @submit="() => submitHandler('dates', dateSelected)"
            @reset-filter="() => resetFilter('dates')"
          />
          <SelectFilter
            v-model="specialitiesSelected"
            title="Специальность"
            :items="specialitiesList"
            :clearble="defaultState['specialityIds']"
            @submit="() => submitHandler('specialityIds', specialitiesSelected)"
            @reset-filter="() => resetFilter('specialityIds')"
          />
        </div>
        <div class="appointment-filter--down">
          <DoctorFilter
            v-model="doctorSelected"
            :items="doctorList"
            :clearble="defaultState['doctorIds']"
            @submit="() => submitHandler('doctorIds', doctorSelected)"
            @reset-filter="() => resetFilter('doctorIds')"
          />
          <SelectFilter
            v-model="statusSelected"
            title="Статус"
            itemTitle="direction"
            :items="statusList"
            :clearble="defaultState['status']"
            @submit="() => submitHandler('status', statusSelected)"
            @reset-filter="() => resetFilter('status')"
          />
        </div>
      </div>
    </SmFilter>
  </div>
</template>
<script>
import { onMounted, ref, toRefs } from '@vue/composition-api'
import { useStore } from '@/store'
import { useDisplay } from '@/hooks'
import { omitByNull } from '@/core/utils'
import { mergeUniqueArrays } from '@/core/helpers'

import { SmFilter } from '@/components/smFilters/components'
import Loader from '@/components/loader'

import { DateFilter, DoctorFilter, SelectFilter } from '../components'
import useFilter from '../hooks/useFilter'

export default {
  name: 'AnalysesFilter',
  components: {
    DateFilter,
    SelectFilter,
    DoctorFilter,
    SmFilter,
    Loader
  },
  props: ['initState'],
  setup(props, ctx) {
    const { initState } = toRefs(props)
    const display = useDisplay()
    const store = useStore()

    const initalLoad = ref(true)
    const isDefault = ref(true)
    const selectCounter = ref(0)
    const defaultState = ref({})

    const statusList = ref([])
    const statusSelected = ref([])

    const specialitiesList = ref([])
    const specialitiesSelected = ref([])

    const biomaterialList = ref([])
    const biomaterialSelected = ref([])

    const doctorList = ref([])
    const doctorSelected = ref([])

    const dateSelected = ref(null)

    function submitHandler(id, value) {
      switch (id) {
        case 'dates':
          ctx.emit('submit', { id, value: value })
          break
        default:
          ctx.emit('submit', { id, value: value.map((v) => v.id) })
      }
    }

    function resetFilter(type) {
      ctx.emit('reset', type)
    }

    function resetFilters() {
      ctx.emit('reset-all-filters')
    }

    onMounted(async () => {
      const payload = omitByNull({
        from: initState.value.from,
        to: initState.value.to,
        dates: initState.value.dates,
        statuses: initState.value.status,
        specialityIds: initState.value.specialityIds,
        biomaterialIds: initState.value.biomaterialIds,
        doctorIds: initState.value.doctorIds
      })

      await store.dispatch('analyses/getAnalysesFiltersPost', payload)

      const filterConfig = [
        {
          id: 'status',
          initial: initState.value.status,
          list: [
            { direction: 'В работе', id: 'AT_WORK' },
            { direction: 'Готов', id: 'READY' },
            { direction: 'Частично выполнен', id: 'PARTIALLY_COMPLETED' },
            { direction: 'Назначен', id: 'SCHEDULED' }
          ]
        },
        {
          id: 'specialityIds',
          initial: initState.value.specialityIds,
          list: store.getters['analyses/getFiltersData'].specialities
        },
        {
          id: 'biomaterialIds',
          initial: initState.value.biomaterialIds,
          list: store.getters['analyses/getFiltersData'].biomaterials
        },
        {
          id: 'doctorIds',
          initial: initState.value.doctorIds,
          list: store.getters['analyses/getFiltersData'].doctors
        }
      ]

      const {
        list,
        selected,
        isDefault: _isDefault,
        selectCounter: _selectCounter,
        defaultState: _defaultState
      } = useFilter(filterConfig)

      statusList.value = list['status']
      statusSelected.value = selected['status']

      specialitiesList.value = list['specialityIds']
      specialitiesSelected.value = selected['specialityIds']

      biomaterialList.value = list['biomaterialIds']
      biomaterialSelected.value = selected['biomaterialIds']

      doctorList.value = list['doctorIds']
      doctorSelected.value = selected['doctorIds']

      isDefault.value = _isDefault
      selectCounter.value = _selectCounter
      defaultState.value = _defaultState

      const filterInitState = store.getters['filter/getInitState']
      let filterStash = null

      if (!filterInitState?.analyses) {
        const analyses = {
          specialitiesList: specialitiesList.value,
          doctorList: doctorList.value,
          biomaterialList: biomaterialList.value
        }
        store.commit('filter/setInitState', { analyses })
        filterStash = store.getters['filter/getInitState']
      } else {
        filterStash = filterInitState.analyses
      }

      if (initState.value.biomaterialIds) {
        if (
          !initState.value.specialityIds &&
          !initState.value.doctorIds &&
          biomaterialList.value.length
        ) {
          biomaterialList.value = mergeUniqueArrays(
            biomaterialList.value,
            filterStash.biomaterialList,
            'id'
          )
        }
      }

      if (initState.value.doctorIds) {
        if (
          !initState.value.biomaterialIds &&
          !initState.value.specialityIds &&
          doctorList.value.length
        ) {
          doctorList.value = mergeUniqueArrays(
            doctorList.value,
            filterStash.doctorList,
            'id'
          )
        }
      }

      if (initState.value.specialityIds) {
        if (
          !initState.value.biomaterialIds &&
          !initState.value.doctorIds &&
          specialitiesList.value.length
        ) {
          specialitiesList.value = mergeUniqueArrays(
            specialitiesList.value,
            filterStash.specialitiesList,
            'id'
          )
        }
      }

      if (initState.value.dates) {
        isDefault.value = false
        selectCounter.value++
        dateSelected.value = {
          calendarMode: 'mulitiple',
          value: initState.value.dates
        }
      }

      if (initState.value.from && initState.value.to) {
        isDefault.value = false
        selectCounter.value++
        dateSelected.value = {
          calendarMode: 'range',
          value: {
            start: initState.value.from,
            end: initState.value.to
          }
        }
      }

      initalLoad.value = false
    })

    return {
      doctorList,
      doctorSelected,
      specialitiesList,
      specialitiesSelected,
      statusList,
      statusSelected,
      biomaterialList,
      biomaterialSelected,
      dateSelected,
      isDefault,
      defaultState,
      selectCounter,
      submitHandler,
      resetFilters,
      resetFilter,
      initalLoad,
      display
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'style';
</style>
